import React from 'react';
import { View, Text, ScrollView } from 'react-native';
import moment from 'moment';
import CustomPressable from '../../components/customPressable/customPressable';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { setGoHome } from '../../Redux/Reducers/appConfigReducer';
import { useDispatch } from 'react-redux';

const NotificationDetail = (props) => {
    const { route, navigation } = props || {};
    const { item } = route.params || {};
    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const handleGoBack = () => {
        if (navigation) {
            navigation.goBack();
            return;
        }

        dispatch(setGoHome(true));
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'notificationDetailRootContainer'])} id="widgetRootContainer notificationDetailRootContainer">
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <View style={getStyles(['widgetmainContainerHeaderContainer', 'notificationDetailHeaderContainer'])} id='widgetmainContainerHeaderContainer notificationDetailHeaderContainer'>
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'notificationDetailHeaderTitleContainer'])} id='widgetmainContainerHeaderTitleContainer notificationDetailHeaderTitleContainer'>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'notificationDetailHeaderTitle'])} id='widgetmainContainerHeaderTitle notificationDetailHeaderTitle'>{item?.messageTitle}</Text>
                </View>
            </View>

            <ScrollView contentContainerStyle={getStyles(['widgetmainContainer', 'notificationDetailMainContainer'])} id="widgetmainContainer notificationDetailMainContainer" showsVerticalScrollIndicator={false}>

                <View style={getStyles(['widgetmainContainerChildContainer', 'notificationDetailMainContainerChildContainer'])} id='widgetmainContainerChildContainer notificationDetailMainContainerChildContainer'>

                    <View style={getStyles(['notificationDetailContainer'])} id='notificationDetailContainer'>

                        <View>
                            <Text style={getStyles(['notificationDetailContainer_datetext'])} id='notificationDetailContainer_datetext'>{t('notification.date_sent')} {moment(item?.dateCreated).format('DD MMM YYYY')}</Text>
                            <Text style={getStyles(['notificationDetailContainer_primarytext'])} id='notificationDetailContainer_primarytext'>{t('notification.from')} {item?.sender}</Text>
                        </View>

                        <View>
                            <Text style={getStyles(['notificationDetailContainer_secondarytext'])} id="notificationDetailContainer_secondarytext">{item?.messageText}</Text>
                        </View>

                    </View>

                    
                </View>
            </ScrollView>


            <View style={getStyles(['footer_button_container', 'guestrequest_button_container'])} id='footer_button_container guestrequest_button_container'>
                <CustomPressable style={getStyles(['primaryBtn'])} id="primaryBtn" onPress={handleGoBack}>
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt' >{t('notification.okay')}</Text>
                </CustomPressable>
            </View>

        </View>
    );
};


export default NotificationDetail;
